module.exports = __webpack_public_path__ + "media/images/application/template/quotemark-4926714170df0bae1e44085e75b7fcda.svg";